import React from 'react';
import { Field, useForm, useFormState } from 'react-final-form';
import { isMobile } from '@zola-helpers/client/dist/es/util/responsive';

import FormInput from '../../../../Form/inputV3/FinalFormInput';
import { REQUIRED, DATE, DATE_AFTER_NOW } from '../../../../Form/util/validations';
import { calendarParser } from '../../../../Form/util/dateUtils';

import OnboardStep, { OnboardStepProps } from '../../../OnboardStep';
import NamesAndDate from '../../panes/NamesAndDate';

import { Row } from '../../../OnboardContainer/OnboardContainer.styles';
import { SPACING } from '../../../../../styles/emotion';
import { SkipDateCheckbox, StyledFormDatePicker } from './NamesAndDateStep.styles';

type NamesAndDateStepProps = Pick<OnboardStepProps, 'portalContent' | 'hed' | 'dek'>;

const NamesAndDateStep = ({
  hed = 'Like any great relationship, this one starts with the basics',
  dek,
  portalContent = <NamesAndDate />,
}: NamesAndDateStepProps): JSX.Element => {
  const { values, valid } = useFormState();
  const form = useForm();

  const DATE_REQUIRED = (value?: string | number, allValues?: Partial<{ skip_date?: boolean }>) =>
    allValues?.skip_date ? undefined : REQUIRED(value);

  return (
    <OnboardStep
      hed={hed}
      dek={dek}
      portalContent={portalContent}
      allFieldsRequired
      showLoginCta
      isValid={valid}
    >
      <Row format="1fr 1fr">
        <FormInput
          name="owner_first_name"
          id="owner_first_name"
          label="First name"
          type="text"
          validate={REQUIRED}
        />
        <FormInput
          name="owner_last_name"
          id="owner_last_name"
          label="Last name"
          type="text"
          validate={[REQUIRED]}
        />
      </Row>
      <Row format="1fr 1fr">
        <FormInput
          name="partner_first_name"
          id="partner_first_name"
          label="Partner's first name"
          type="text"
          validate={[REQUIRED]}
        />
        <FormInput
          name="partner_last_name"
          id="partner_last_name"
          label="Partner's last name"
          type="text"
          validate={[REQUIRED]}
        />
      </Row>
      <Row format="1fr 1fr" gridGap={isMobile() ? SPACING.XS : SPACING.S16}>
        <StyledFormDatePicker
          name="event_date"
          id="event_date"
          label="When are you getting married?"
          validate={[DATE, DATE_AFTER_NOW, DATE_REQUIRED]}
          disabled={values.skip_date}
          preventPastMonthsView
          parseDate={calendarParser}
          alignment="vertical"
        />
        <Field
          name="skip_date"
          component={SkipDateCheckbox}
          id="checkbox-skip_date"
          type="checkbox"
          label="We're still deciding"
          onClick={() => form.change('event_date', undefined)}
        />
      </Row>
    </OnboardStep>
  );
};

export default NamesAndDateStep;
